/* Chef Hassan's Kitchen: core behaviour (header, reveals, lightbox, popup, forms).
   Plain JavaScript, no dependencies. The cart lives in chk-cart.js. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------- header */
  var header = $('[data-header]');
  var nav = $('[data-nav]');
  var drawer = $('[data-drawer]');
  var scrim = $('.Header-scrim');
  var openMenu = null;
  var hoverOpenedAt = 0;

  function setMenu(id) {
    openMenu = id;
    $$('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', String(b.dataset.menuToggle === id)); });
    $$('[data-menu-panel]').forEach(function (p) {
      var on = p.dataset.menuPanel === id;
      p.dataset.open = String(on);
      if (on) p.removeAttribute('inert'); else p.setAttribute('inert', '');
    });
  }

  function setDrawer(on) {
    if (!drawer) return;
    drawer.dataset.open = String(on);
    if (scrim) scrim.dataset.open = String(on);
    if (on) drawer.removeAttribute('inert'); else drawer.setAttribute('inert', '');
    var t = $('[data-drawer-toggle]');
    if (t) {
      t.setAttribute('aria-expanded', String(on));
      t.setAttribute('aria-label', on ? 'Close menu' : 'Open menu');
      var burger = $('.Header-burger', t);
      if (burger) burger.dataset.open = String(on);
    }
    document.body.style.overflow = on ? 'hidden' : '';
    if (on) { var first = $('a, button', drawer); if (first) first.focus(); }
  }

  if (header) {
    $$('[data-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.menuToggle;
        // A click right after a hover-open shouldn't close it again.
        if (openMenu === id && Date.now() - hoverOpenedAt > 500) setMenu(null); else setMenu(id);
      });
      btn.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || openMenu === btn.dataset.menuToggle) return;
        hoverOpenedAt = Date.now();
        setMenu(btn.dataset.menuToggle);
      });
    });
    $$('[data-menu-panel]').forEach(function (p) {
      p.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') setMenu(null); });
    });
    $$('.Header-navLink:not([data-menu-toggle])').forEach(function (a) {
      a.addEventListener('pointerenter', function () { setMenu(null); });
    });
    document.addEventListener('pointerdown', function (e) {
      if (openMenu && nav && !nav.contains(e.target)) setMenu(null);
    });
    window.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (openMenu) setMenu(null);
      if (drawer && drawer.dataset.open === 'true') setDrawer(false);
    });
    var tgl = $('[data-drawer-toggle]');
    if (tgl) tgl.addEventListener('click', function () { setDrawer(drawer.dataset.open !== 'true'); });
    $$('[data-drawer-close]').forEach(function (el) { el.addEventListener('click', function () { setDrawer(false); }); });

    // Tucks away on scroll down, returns on scroll up.
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var hide = y > 160 && y > lastY && !openMenu && !(drawer && drawer.dataset.open === 'true');
      header.dataset.hidden = String(hide);
      if (y > lastY) setMenu(null);
      lastY = y;
    }, { passive: true });
  }

  /* --------------------------------------------------------------- reveals */
  // Single elements go as soon as they peek in; choreographed groups wait until they are
  // a quarter of the way up the screen so the whole sequence plays where people can see it.
  (function () {
    var singles = $$('.reveal:not(.is-visible), .reveal-img:not(.is-visible)');
    var groups = $$('.reveal-group:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      singles.concat(groups).forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var show = function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    };
    var early = new IntersectionObserver(show, { rootMargin: '0px 0px -8% 0px' });
    var late = new IntersectionObserver(show, { rootMargin: '0px 0px -25% 0px' });
    singles.forEach(function (el) { early.observe(el); });
    groups.forEach(function (el) { late.observe(el); });
    // Sections added in the theme editor.
    document.addEventListener('shopify:section:load', function (e) {
      $$('.reveal, .reveal-img', e.target).forEach(function (el) { el.classList.add('is-visible'); });
      $$('.reveal-group', e.target).forEach(function (el) { el.classList.add('is-visible'); });
    });
  })();

  /* ------------------------------------------------------ mobile action bar */
  var bar = $('[data-mobile-bar]');
  if (bar) {
    var onScroll = function () {
      var on = window.scrollY > 380;
      bar.dataset.shown = String(on);
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ------------------------------------------------- "start your inquiry" */
  // Jumps to the form on the same page, with the inquiry type already chosen.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-inquire]');
    if (!a) return;
    var target = document.getElementById('inquire');
    if (!target) return;
    e.preventDefault();
    var sel = document.getElementById('inquiry');
    if (sel && a.dataset.inquire) {
      Array.prototype.forEach.call(sel.options, function (o) { if (o.text === a.dataset.inquire || o.value === a.dataset.inquire) sel.value = o.value; });
    }
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.setTimeout(function () { var n = document.getElementById('contact-name'); if (n) n.focus({ preventScroll: true }); }, 600);
  });

  /* -------------------------------------------------------------- lightbox */
  var lb = $('[data-lightbox-dialog]');
  if (lb) {
    var lbImg = $('[data-lightbox-image]', lb);
    var lbCount = $('[data-lightbox-count]', lb);
    var items = [];
    var idx = 0;
    var big = function (src) {
      if (src.indexOf('cdn.shopify.com') === -1) return src;
      return src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '') + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1800';
    };
    var render = function () {
      var it = items[idx];
      if (!it) return;
      lbImg.src = big(it.src);
      lbImg.alt = it.alt;
      // Re-trigger the ease-in each time.
      lbImg.style.animation = 'none'; void lbImg.offsetWidth; lbImg.style.animation = '';
      var many = items.length > 1;
      lbCount.textContent = many ? (idx + 1) + ' / ' + items.length : '';
      $$('[data-lightbox-prev],[data-lightbox-next]', lb).forEach(function (b) { b.hidden = !many; });
      if (many) [1, -1].forEach(function (d) { var n = items[(idx + d + items.length) % items.length]; if (n) new Image().src = big(n.src); });
    };
    var step = function (d) { if (items.length) { idx = (idx + d + items.length) % items.length; render(); } };
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var el = e.target.closest('[data-lightbox]');
      if (!el) return;
      e.preventDefault();
      var group = $$('[data-lightbox="' + el.dataset.lightbox + '"]');
      items = group.map(function (g) {
        var img = $('img', g);
        return { src: g.dataset.lightboxSrc || g.getAttribute('href') || '', alt: g.dataset.lightboxAlt || (img && img.alt) || '' };
      });
      idx = group.indexOf(el);
      render();
      lb.showModal();
      document.body.style.overflow = 'hidden';
    });
    lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    lb.addEventListener('close', function () { document.body.style.overflow = ''; });
    $('[data-lightbox-close]', lb).addEventListener('click', function () { lb.close(); });
    $('[data-lightbox-prev]', lb).addEventListener('click', function () { step(-1); });
    $('[data-lightbox-next]', lb).addEventListener('click', function () { step(1); });
    window.addEventListener('keydown', function (e) {
      if (!lb.open) return;
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    });
    var tx = null;
    lb.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (tx === null) return;
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 50) step(dx < 0 ? 1 : -1);
      tx = null;
    });
  }

  /* ------------------------------------------------------------------ video */
  // Click-to-load Vimeo player, so the iframe's weight isn't paid until someone presses play.
  $$('[data-video]').forEach(function (box) {
    var btn = $('[data-video-play]', box);
    if (!btn) return;
    btn.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = 'https://player.vimeo.com/video/' + box.dataset.vimeo + '?autoplay=1&dnt=1';
      f.title = box.dataset.title;
      f.allow = 'autoplay; fullscreen; picture-in-picture';
      f.allowFullscreen = true;
      box.innerHTML = '';
      box.appendChild(f);
    });
  });

  /* ----------------------------------------------------- mailing-list forms */
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) { /* storage unavailable */ } }
  };
  var popup = $('[data-popup]');

  $$('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var status = $('[data-newsletter-status]', form);
      var btn = $('button[type=submit]', form);
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Joining…';
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (res) {
          // Shopify answers a good signup by redirecting back with ?customer_posted=true.
          var ok = res.ok && res.url.indexOf('customer_posted=true') > -1;
          if (ok) {
            store.set('chk_subscribed', '1');
            if (popup && popup.contains(form)) {
              $('[data-popup-ask]', popup).hidden = true;
              $('[data-popup-done]', popup).hidden = false;
            } else {
              status.className = 'NewsletterForm-status';
              status.textContent = "Thanks, you're on the list.";
              form.reset();
            }
          } else {
            status.className = 'NewsletterForm-error';
            status.textContent = 'Please check your email address and try again.';
          }
        })
        .catch(function () { status.className = 'NewsletterForm-error'; status.textContent = 'Something went wrong. Please try again.'; })
        .then(function () { btn.disabled = false; btn.textContent = label; });
    });
  });
  // The no-JavaScript path lands back here with a result in the URL.
  if (/customer_posted=true/.test(location.search)) store.set('chk_subscribed', '1');

  if (popup) {
    var SNOOZE = 14 * 24 * 60 * 60 * 1000;
    var due = function () {
      if (store.get('chk_subscribed')) return false;
      var d = Number(store.get('chk_popup_dismissed'));
      return !d || Date.now() - d > SNOOZE;
    };
    var quiet = window.CHK.template === 'cart' || /\/pages\/contact/.test(location.pathname);
    if (due() && !quiet) {
      window.setTimeout(function () { if (due() && !document.querySelector('dialog[open]')) popup.showModal(); }, 5000);
    }
    var joined = false;
    $$('[data-popup-close]', popup).forEach(function (b) { b.addEventListener('click', function () { popup.close(); }); });
    popup.addEventListener('click', function (e) { if (e.target === popup) popup.close(); });
    popup.addEventListener('close', function () { if (!store.get('chk_subscribed')) store.set('chk_popup_dismissed', String(Date.now())); });
    var copy = $('[data-popup-copy]', popup);
    if (copy) copy.addEventListener('click', function () {
      if (navigator.clipboard) navigator.clipboard.writeText(popup.dataset.code).then(function () { copy.textContent = 'Copied'; });
    });
  }

  /* ------------------------------------------- scroll cue for the category bar */
  // The menu's category bar and the Catering / Household / Seasoned Meats tabs scroll sideways when they're wider
  // than the screen. Fades and arrows at the edges show there's more, a tap on an arrow moves along, and once per
  // visit each bar gives a small nudge.
  $$('.Collection-jump, .Collection-tabs').forEach(function (nav) {
    var list = $('ul', nav);
    if (!list) return;
    var chevron = function (flip) { return '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"' + (flip ? ' style="transform:scaleX(-1)"' : '') + '><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; };
    var mk = function (dir) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'Collection-jumpArrow'; b.dataset.dir = dir; b.tabIndex = -1;
      b.setAttribute('aria-hidden', 'true'); b.innerHTML = chevron(dir === 'prev');
      b.addEventListener('click', function () { list.scrollBy({ left: (dir === 'next' ? 1 : -1) * Math.max(160, list.clientWidth * 0.6), behavior: 'smooth' }); });
      nav.appendChild(b);
      return b;
    };
    var prev = mk('prev'), next = mk('next');
    var update = function () {
      var max = list.scrollWidth - list.clientWidth;
      var scrolls = max > 6;
      prev.toggleAttribute('data-show', scrolls && list.scrollLeft > 6);
      next.toggleAttribute('data-show', scrolls && list.scrollLeft < max - 6);
    };
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    window.setTimeout(update, 400);
    // One small nudge per visit, only if there is more to the right and motion is welcome.
    var key = nav.classList.contains('Collection-tabs') ? 'chk_tabs_nudge' : 'chk_cat_nudge';
    var seen = store.get(key);
    if (!seen && list.scrollWidth - list.clientWidth > 40 && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      window.setTimeout(function () {
        var start = list.scrollLeft;
        list.scrollTo({ left: start + 70, behavior: 'smooth' });
        window.setTimeout(function () { list.scrollTo({ left: start, behavior: 'smooth' }); }, 750);
        store.set(key, '1');
      }, 900);
    }
  });
})();
